import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/TopMenu.css';

function TopMenu({ pageTitle, email, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="top-menu">
      <div className="menu-content">
        <div className="menu-branding">
          <NavLink to="/" className="menu-logo-link">
            {pageTitle && <h2 className="page-title">{pageTitle}</h2>}
          </NavLink>
        </div>

        <button
          className={`hamburger-menu ${isOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div className={`menu-links ${isOpen ? 'active' : ''}`}>
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/orders"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Orders
          </NavLink>
          <NavLink
            to="/returns"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Returns
          </NavLink>
          <NavLink
            to="/warehouses"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Warehouses
          </NavLink>
          <NavLink
            to="/brands"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Brands
          </NavLink>
          <NavLink
            to="/celebs"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Celebrities
          </NavLink>
          <NavLink
            to="/ledger"
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Ledger
          </NavLink>
          <NavLink
            to="/outfits"
            className={({ isActive }) =>
              `menu-link ${
                isActive || window.location.pathname.startsWith('/outfits') ? 'active' : ''
              }`
            }
            onClick={closeMenu}
          >
            Outfit Studio
          </NavLink>
          <NavLink
            to="/admin"
            end
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Admin
          </NavLink>
          <button className="sign-out-button" onClick={onLogout}>
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default TopMenu;
